import Seo, { organizationSchema } from "@/lib/Seo";
import Hero from "@/components/home/Hero";
import AboutIntro from "@/components/home/AboutIntro";
import VideoPresentation from "@/components/home/VideoPresentation";
import BlogPreview from "@/components/home/BlogPreview";
import StatsBars from "@/components/home/StatsBars";
import Filieres from "@/components/home/Filieres";
import TrustedBy from "@/components/home/TrustedBy";
import FormationsPreview from "@/components/home/FormationsPreview";
import Etapes from "@/components/home/Etapes";
import CampusGallery from "@/components/home/CampusGallery";
import MetiersCarousel from "@/components/home/MetiersCarousel";
import CentresPreview from "@/components/home/CentresPreview";
import CalendarSection from "@/components/home/CalendarSection";
import VideoTestimonial from "@/components/home/VideoTestimonial";
import DiagonalMarquee from "@/components/home/DiagonalMarquee";
import Testimonials from "@/components/home/Testimonials";
import Articles from "@/components/home/Articles";
import FaqSection from "@/components/home/FaqSection";
import FinalCtaDual from "@/components/home/FinalCtaDual";

export default function Home() {
  return (
    <>
      <Seo
        title="Formations transport, permis & enseignants"
        description="EDUCASER GROUP, regroupement d'organismes de formation dédié aux métiers de la route et de la mobilité : transport de marchandises, de voyageurs et enseignement de la conduite. Permis, FIMO, FCO et titres professionnels en Île-de-France."
        path="/"
        schema={organizationSchema}
      />
      <Hero />
      <AboutIntro />
      <VideoPresentation />
      <StatsBars />
      <Filieres />
      <TrustedBy />
      <FormationsPreview />
      <Etapes />
      <CampusGallery />
      <MetiersCarousel />
      <VideoTestimonial />
      <DiagonalMarquee />
      <FinalCtaDual />
      <Articles />
      <CentresPreview />
      <CalendarSection />
      <BlogPreview />
      <Testimonials />
      <FaqSection />
    </>
  );
}
